import { Link } from 'react-router-dom';
import { hotAnimeList } from '@/mocks/home';

export default function HotRecommendSection() {
  return (
    <section id="hot-recommend" className="w-full px-4 md:px-6 lg:px-12 py-14 md:py-20 bg-background-100">
      <div className="flex flex-col lg:flex-row lg:items-end gap-4 mb-10">
        <div className="lg:w-[45%]">
          <span className="text-sm text-foreground-500 font-medium">热门精选</span>
          <h2 className="text-3xl md:text-4xl font-heading text-foreground-950 mt-1">
            大家都在看
          </h2>
        </div>
        <p className="lg:w-[55%] text-sm text-foreground-600 leading-relaxed">
          精选当下最受欢迎的国产动漫作品，无论是热血玄幻还是轻松日常，总有一部适合你。每日实时更新，让你永远不错过精彩瞬间。
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
        {hotAnimeList.map((anime, idx) => (
          <Link
            key={anime.id}
            to={anime.link}
            className={`group rounded-lg overflow-hidden bg-background-50 hover:bg-background-50/80 transition-colors ${
              idx === 1 ? 'lg:-mt-4 lg:mb-4' : ''
            }`}
          >
            <div className="relative w-full h-[220px] md:h-[260px] overflow-hidden">
              <img
                src={anime.image}
                alt={anime.title}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute top-3 left-3">
                <span className={`inline-block px-2.5 py-1 rounded-full text-xs font-medium ${anime.categoryColor}`}>
                  {anime.category}
                </span>
              </div>
              <div className="absolute top-3 right-3 flex items-center gap-1 bg-background-950/70 backdrop-blur-sm px-2 py-1 rounded-full">
                <i className="ri-star-fill text-secondary-500 text-xs"></i>
                <span className="text-background-50 text-xs font-medium">{anime.rating}</span>
              </div>
            </div>
            <div className="p-4 md:p-5">
              <h3 className="text-lg font-heading text-foreground-950 group-hover:text-primary-600 transition-colors">
                {anime.title}
              </h3>
              <p className="text-sm text-foreground-500 mt-1">{anime.subtitle}</p>
              <p className="text-sm text-foreground-600 mt-3 line-clamp-2 leading-relaxed">
                {anime.description}
              </p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}